import React from "react";
import { Route, Switch } from "react-router-dom";

import { useAutomatedSignUp } from "scenes/Authentication/hooks";

import {
  AuthenticationRoutes,
  LegacyAuthenticationRoutes,
} from "./unauthenticated";

function UnauthenticatedRoutes() {
  const { automatedSignUp, loadingConfig } = useAutomatedSignUp();

  if (loadingConfig) {
    return null;
  }

  return (
    <Switch>
      {automatedSignUp && (
        <Route path="/v2">
          <AuthenticationRoutes />
        </Route>
      )}

      <Route>
        <LegacyAuthenticationRoutes />
      </Route>
    </Switch>
  );
}

export default UnauthenticatedRoutes;
